import { requestApi } from '../util/network'

export const forget =
    (userName, captcha, password, confirmPassword) =>
      requestApi(
        '/Connect/find_password',
        'POST',
        {
          'phone': userName,
          'captcha': captcha,
          'password': password,
          'password_confirm': confirmPassword,
          'client': 'wap'
        }
      )
//获取邮箱验证码      
export const getemailcode =
    (email) =>
      requestApi(
        '/Connectemail/get_captcha',
        'POST',
        {
          'email': email
        }
      )      

//邮箱找回密码提交      
export const forgetemail =
    (email, captcha, password) =>
      requestApi(
        '/Connectemail/find_password',
        'POST',
        {
          'email': email,
          'captcha': captcha,
          'password': password
        }
      )